import { ContractProfileDtoToEntity } from "src/app/features/ContractProfile/services/mappers/ContractProfileDtoToEntity";
import type { ContractProfileDto } from "src/app/features/ContractProfile/types/ContractProfileDto";
import type { ContractProfileEntity } from "src/app/features/ContractProfile/types/ContractProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ContractProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<ContractProfileDto>>,
): ResourcePageEntity<ContractProfileEntity> => {
    return {
        list: input.list ? input.list.map(ContractProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
